import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthorizationService, StorageManagerService } from '../services';
import { Observable, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ICustomer } from '../models';

@Injectable()
export class SubstanceLookupGuard implements CanActivate, CanLoad {

  constructor(private router: Router, private authorizationService: AuthorizationService, private toastr: ToastrService, private storage: StorageManagerService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkAccess();
  }

  canDeactivate(component: any):Observable<boolean> | Promise<boolean> | boolean  {
    return component.canDeactivate();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
        return this.checkAccess();
  }

  private checkAccess(): Observable<boolean> {
    let hasPermission = true;

    const cust = this.storage.read('currentCustomer');
    let currentCustomer: ICustomer;
    
    if (cust) {
      currentCustomer = typeof cust === 'object' ? cust : JSON.parse(cust);
    }

    hasPermission = this.authorizationService.hasPermission('SSDP.CanValidateSubstanceLookup');

    if (!hasPermission) {
        this.toastr.error('You do not have access to this page.');
        this.router.navigate(['/home']);
    }

    return of(hasPermission) ;
  }
}
